import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { catchError, throwError } from 'rxjs';
import { AuthEventsService } from '../../shared/services/shared/auth-events.service';
import { LOGOUT_ON_401 } from './auth-context';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const modal = inject(NzMessageService);
  const authEvents = inject(AuthEventsService);
  const logoutOn401 = req.context.get(LOGOUT_ON_401);
  return next(req).pipe(
    catchError((error) => {
      if ([401, 403].includes(error?.status) && logoutOn401) {
        authEvents.requestLogout();
        return throwError(() => error);
      }

      let errorMessage = 'An unexpected error occurred';

      const message1 = error?.error?.error?.message;
      if (message1) {
        // Extract error message from Strapi response
        errorMessage = Array.isArray(message1)
          ? message1[0].messages[0].message
          : message1;
      } else if (error.message) {
        errorMessage = error.message;
      }

      modal.error(errorMessage);
      return throwError(() => error);
    }),
  );
};
